<div class="modulo-maps {{classCustom}}">
  <div class="maps" #maps></div>
</div>
     